import React, { Component } from 'react'
import styled from 'styled-components'

import { connect } from 'react-redux'
import { toggleCategory } from '../actions'

import { NavLink } from 'react-router-dom'

import { slugify } from '../utils'

import DropdownArrrow from './visuals/DropdownArrow'

const Wrap = styled.li`
  font-family: 'Source Sans Pro';
  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;
  cursor: default;

  ul.subcategories {
    margin-top: 8px;
    margin-bottom: 8px;
  }

  .active li {
    border-color: #CCA633 !important;
  }

  ul.subcategories li {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    /* According to design it's 40px from the left. 40 - parent's margin = 16px */
    margin-left: -24px;
    padding-left: 40px;
    border-left: 6px solid rgba(0,0,0,0);
    transition: 0.4s border;

    font-family: 'Source Sans Pro';
    font-size: 14px;
    font-weight: bold;
    line-height: 26px;
    text-transform: none;
  }
`

const mapStateToProps = (state, ownProps) => {
  const category = ownProps.title.split(' ')[0].toLowerCase()
  return {
    category,
    isOpen: state.sidebar[`${category}IsOpen`]
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  toggle: (category) => dispatch(toggleCategory(category))
})

let SidebarCategory = (props) => (
  <Wrap>
    <div onClick={() => props.toggle(props.category)}>
      <span>{props.title}</span>
      <DropdownArrrow isOpen={props.isOpen} width='9' height='12' />
    </div>

    {props.isOpen ?
      <ul className='subcategories'>
        {props.books.map( bookSlug => (
          <NavLink to={`${process.env.REACT_APP_APP_HOIST}/${slugify(bookSlug)}`} key={bookSlug}><li>{bookSlug}</li></NavLink>
        ))}
      </ul>
    : null}
  </Wrap>
)

SidebarCategory = connect(mapStateToProps, mapDispatchToProps)(SidebarCategory)

export default SidebarCategory



// WEBPACK FOOTER //
// ./src/components/SidebarCategory.js